import { nextQuestionSelectContext } from "#/admin/legacy/assessment-builder/next-question-select.js";
import "#legacy/admin/assessment_builder/_generated_templates.js";
import "#legacy/admin/assessment_builder/views/base.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.ResponseFormNextQuestionSelect = class ResponseFormNextQuestionSelect extends (
  AssessmentBuilder.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
    this.handleQuestionsListChange = this.handleQuestionsListChange.bind(this);
    this.updateFilteredQuestions = this.updateFilteredQuestions.bind(this);
  }

  initialize() {
    super.initialize(...arguments);

    this.question = this.model.get("question");
    this.questions = this.question.get("assessment").get("questions");

    this.listenTo(this.questions, "change:title", this.render);
    this.listenTo(this.questions, "add remove", this.handleQuestionsListChange);
    return this.updateFilteredQuestions();
  }

  render() {
    this.$el.html(
      this.template(
        nextQuestionSelectContext(
          this.model.attributes,
          this.selectItems.next_question,
          this.filteredQuestions.map((question) => question.attributes),
        ),
      ),
    );
    return this;
  }

  // EVENT HANDLERS

  handleQuestionsListChange() {
    this.updateFilteredQuestions();
    return this.render();
  }

  // HELPER METHODS

  updateFilteredQuestions() {
    return (this.filteredQuestions = this.questions.filter((question) => question.id !== this.question.id));
  }
};
AssessmentBuilder.Views.ResponseFormNextQuestionSelect.prototype.tagName = "free-text-response-form";
AssessmentBuilder.Views.ResponseFormNextQuestionSelect.prototype.template = _.template(
  AssessmentBuilder.Templates.Response.Form.next_question_select,
);
